export const APP_CONTENT_MAX_WIDTH = 1680;

export const SETTINGS_FIELD_MAX_WIDTH = 520;

export const appContentGutter = {
  xs: 2,
  md: `max(24px, calc((100vw - ${APP_CONTENT_MAX_WIDTH}px) / 2))`,
};
